export default __webpack_public_path__ + "static/favicon-26d9a83b9c33c7b3e7799098196bebdb.ico";